module.exports = __webpack_public_path__ + "img/rondexter.bd1937a5.svg";